import * as yup from 'yup';
import { isEmail, type Value } from '@zurich-client/validator/utils';

export const postalCodeSchema = yup
  .string()
  .min(4, 'maxFourCharacters')
  .max(4, 'maxFourCharacters')
  .nullable()
  .required('required');

export const wubInputSchema = yup.string().required('required');

export const checkboxSchema = yup
  .boolean()
  .nullable()
  .oneOf([true], 'required');

const oneTwoLettersMinusOptionalThreeSixLettersOrNumbers = (value: Value) => {
  if (!value) {
    return false;
  }
  return /^[A-PR-Z]{1,2}-[A-PR-Z0-9]{3,6}$/.test(value);
};

export const licensePlateVSGASchema = yup
  .string()
  .test(
    'first 1-2 characters are uppercase letters, followed by an optional "-", followed by 3-6 uppercase letters or numbers',
    '1',
    oneTwoLettersMinusOptionalThreeSixLettersOrNumbers
  )
  .min(4, 'required')
  .max(9, '1')
  .nullable();

const firstCharIsUppercaseDashOrNumber = (value: Value) =>
  value ? /^[A-Z1-9\s][A-Z0-9\-\s@]*$/.test(value) : true;

export const licensePlateVSGALiveSchema = yup
  .string()
  .test(
    'first character is uppercase letter or number greater than zero',
    '1',
    firstCharIsUppercaseDashOrNumber
  )
  .min(0)
  .max(9, '1')
  .nullable();

export const imageSchema = yup.string().nullable().required('required');

export const damagedFieldSchema = yup.string().nullable().required('required');

export const partyEmailSchema = yup
  .string()
  .nullable()
  .test('isEmail', '1', isEmail)
  .required('2');

export const partyNameSchema = yup
  .string()
  .max(50)
  .nullable()
  .required('required')
  .test('partyIsNoSpecialCharacterAndLength', 'required', (value) => {
    if (value) {
      return /[\u00C0-\u0192a-zA-Z]{2,}/.test(value || '');
    }
    return false;
  });

export function partyIsNameCharacters(
  value: string | null | undefined
): boolean {
  return /^([\u00C0-\u0192a-zA-Z\s-]*)$/.test(value || '');
}

export const partyNameLiveSchema = yup
  .string()
  .test('isNameCharacters', 'none', partyIsNameCharacters);
